import template from './liability.template.html';

export default {
  template,
  bindings: {
    liability: '<',
    liabilities: '<',
    assets: '<',
    contacts: '<',
    workflow: '<',
    lenders: '<',
    validationErrors: '<',
    isContactLiability: '<',
    isTicketSettled: '<',
    onChangedLinkedAsset: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdMedia,
      helperService,
      assetsService,
      liabilitiesService,
      dateTimeService,
      Liability,
      CreditCardType,
      GOOGLEMAPS
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.organizationCountry = null;
      ctrl.availableStates = [];
      ctrl.availableAssetTypes = [];
      ctrl.availableCreditCardTypes = [];
      ctrl.availableLiabilityTypes = [];
      ctrl.linkedAssets = [];
      ctrl.appropriateLenders = [];
      ctrl.searchTerm = '';
      ctrl.otherDateFormat = $rootScope.CurrentDateFormatSecondary();
      ctrl.dateFormat = helperService.setOtherDateFormat;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.googleAutocompleteOptions = {
          componentRestrictions: GOOGLEMAPS.restrictToCountries
        };
        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.availableAssetTypes = assetsService.getAvailableAssetTypes();
        ctrl.availableCreditCardTypes = CreditCardType.available();
        ctrl.availableLiabilityTypes = liabilitiesService.getAvailableLiabilityTypes();
        ctrl.liability = ctrl.liability || {};
        ctrl.liabilities = ctrl.liabilities || [];
        ctrl.assets = ctrl.assets || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.workflow = ctrl.workflow || {};
        ctrl.lenders = ctrl.lenders || [];
        if (ctrl.lenders.length) {
          ctrl.setAppropriateLenders();
        }
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.index = _.findIndex(ctrl.liabilities, (l) => l?.id === ctrl.liability?.id);
        dateTimeService.getSet(
          ctrl,
          ctrl.liability,
          'interestOnlyExpiryDate',
          'getSetInterestOnlyExpiryDate'
        );

        dateTimeService.getSet(
          ctrl,
          ctrl.liability,
          'fixedExpiryDate',
          'getSetFixedExpiryDate'
        );

        dateTimeService.getSet(ctrl, ctrl.liability, 'endDate', 'getSetEndDate');

        dateTimeService.getSet(ctrl, ctrl.liability, 'asAtDate', 'getSetAsAtDate');

        dateTimeService.getSet(ctrl, ctrl.liability, 'timeStamp', 'getTimeStamp');

        ctrl.isContactLiability = ctrl.isContactLiability || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.getLinkedAssets();
      };

      ctrl.setAppropriateLenders = () => {
        let type = 'RESIDENTIAL';
        if (ctrl.isLiabilityTypeVehicle()) {
          type = 'ASSET_FINANCE';
        }
        if (ctrl.isLiabilityTypePersonal()) {
          type = 'PERSONAL';
        }

        ctrl.appropriateLenders = _.chain(ctrl.lenders)
          .filter((l) => l.type.indexOf(type) > -1)
          .sortNatural('name')
          .sortNatural('group')
          .value();
      };

      ctrl.clearSearchTerm = () => {
        ctrl.searchTerm = '';
      };

      ctrl.getLinkedAssets = () => {
        ctrl.linkedAssets = assetsService.getLinkedAssets(
          ctrl.liability.liabilityType.id,
          ctrl.assets
        );
      };

      ctrl.getContact = (idContact) => {
        let contact;
        if (ctrl.contacts.length) {
          contact = ctrl.contacts.find((c) => c.id === idContact);
        }
        return contact;
      };

      ctrl.editOwnership = (event, liability) =>
        helperService
          .editOwnershipOfAssetOrLiability({
            event,
            item: liability,
            contacts: ctrl.contacts,
            isDisabled: ctrl.isTicketSettled
          })
          .then((result) => {
            ctrl.liability = Liability.build(result);
            ctrl.saveLiability();
          });

      ctrl.changeLinkedAsset = () => {
        ctrl.saveLiability();
        ctrl.onChangedLinkedAsset({ liability: ctrl.liability });
      };

      ctrl.clearSearchTerm = () => {
        ctrl.searchTerm = '';
      };

      ctrl.isLenderSelected = (liability) => {
        if (liability.name !== '' && ctrl.appropriateLenders.length) {
          const lS = ctrl.appropriateLenders.find(
            (l) => l.abbr.toLowerCase() === liability.name
          );
          return lS !== undefined;
        }
        return true;
      };

      ctrl.isLiabilityTypeLoan = () =>
        helperService.isLiabilityTypeLoan(ctrl.liability.liabilityType);

      ctrl.isLiabilityTypeMortgageOrVehicleOrSmsf = () =>
        helperService.isLiabilityTypeMortgageOrVehicleOrSmsf(ctrl.liability.liabilityType);

      ctrl.isLiabilityTypeMortgageOrSmsfLoan = () =>
        helperService.isLiabilityTypeMortgageOrSmsfLoan(ctrl.liability.liabilityType);

      ctrl.isLiabilityTypeMortgage = () =>
        helperService.isLiabilityTypeMortgage(ctrl.liability.liabilityType);

      ctrl.isLiabilityTypeCreditCard = () =>
        helperService.isLiabilityTypeCreditCard(ctrl.liability.liabilityType);

      ctrl.isLiabilityTypeOverdraft = () =>
        helperService.isLiabilityTypeOverdraft(ctrl.liability.liabilityType);

      ctrl.isLiabilityTypeVehicle = () =>
        helperService.isLiabilityTypeVehicle(ctrl.liability.liabilityType);

      ctrl.isLiabilityTypePersonal = () =>
        helperService.isLiabilityTypePersonal(ctrl.liability.liabilityType);

      ctrl.isLiabilityTypeSmsf = () =>
        helperService.isLiabilityTypeSmsf(ctrl.liability.liabilityType);

      ctrl.isLiabilityTypeEducationDebt = () =>
        helperService.isLiabilityTypeEducationDebt(ctrl.liability.liabilityType);

      ctrl.isLiabilityTypeOther = () =>
        helperService.isLiabilityTypeOther(ctrl.liability.liabilityType);

      ctrl.isLiabilityTypeBalanceSheet = () =>
        helperService.isLiabilityTypeBalanceSheet(ctrl.liability.liabilityType);

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.isLoanTermValid = () => {
        if (!ctrl.liability?.endDate) {
          return true;
        }
        return dateTimeService
          .getMoment(ctrl.liability.endDate)
          .isBefore(dateTimeService.getMoment(dateTimeService.epoch()));
      };

      ctrl.hasError = () => {
        const errors = [];
        if (
          ctrl.isLiabilityTypeLoan() ||
          ctrl.isLiabilityTypeCreditCard() ||
          ctrl.isLiabilityTypeOverdraft()
        ) {
          errors.push(!ctrl.liability?.name);
          if (ctrl.isLiabilityTypeLoan()) {
            errors.push(!ctrl.liability?.balance, ctrl.isLoanTermValid());
          }
          if (ctrl.isLiabilityTypeMortgageOrVehicleOrSmsf()) {
            errors.push(!ctrl.liability?.idAsset);
          }
          if (ctrl.isLiabilityTypeCreditCard() || ctrl.isLiabilityTypeOverdraft()) {
            errors.push(!ctrl.liability?.limit);
          }
        }
        return _.some(errors, (e) => e === true);
      };

      ctrl.saveLiability = () => ctrl.onFinished({ liability: ctrl.liability });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
